import {FACTIONS} from "../constants/factions";
import {LEAGUES} from "../constants/leagues";

// Фракции, которые НЕ достаются ботам при случайном/автоматическом выборе —
// при любом способе получить фракцию БЕЗ явного выбора игроком:
//  - обычное сетевое лобби, бот выбирает сам после паузы
//    (см. scheduleBotFactionSelection в server/index.js);
//  - рейтинговое лобби — и подбор матча, и бот-против-бот
//    (см. pickRankMatchBotFactionId в server/index.js);
//  - демо-партия главного меню (MenuDemoGame).
// Запрет действует одинаково в рейтинге и в обычных сетевых партиях. Выбор
// фракции реальным игроком список не ограничивает — он только про ботов.
//
// Сейчас здесь все фракции без implemented: true (боты по ним и так не играют,
// но список страхует от случайного попадания при их включении).
// Великаны, суккубы и гоблины допускаются по лиге бота — см. BOT_FACTION_MIN_LEAGUE ниже.
// Селестиалы доступны ботам всех лиг: индекс побед 0.87–1.08 выше самой слабой разрешенной
// фракции в каждой лиге (отчет 41).
export const BOT_EXCLUDED_FACTIONS = [
  FACTIONS.AQUARS,
  FACTIONS.DARK_ELVES,
  FACTIONS.DOPPLERS,
  FACTIONS.DRAGONS,
  FACTIONS.ENTS,
  FACTIONS.FENIX,
  FACTIONS.GREMLINS,
  FACTIONS.MUSHROOM_PEOPLE,
  FACTIONS.SPIRITS,
  FACTIONS.TECHNODWARVES,
  FACTIONS.UNDEAD,
  FACTIONS.WIZARDS,
];

// Волна 39: фракции, за которые боты играют, но слабее прочих без бонуса лиги.
// Фракция достается боту, только если его лига не ниже указанной (отчет 37,
// developer_artifacts/bot_strategy/simulations/simulation_report_37.md).
// Лига бота — getBotFactionLeagueId: у явного бота рейтингового матча — его
// лига (по ней и бонус), у всех остальных ботов бонуса нет — бронза.
//  - суккубы: с серебра индекс побед 0.89 / 0.72 / 0.65 / 0.79 / 0.91 (серебро …
//    божество) не ниже самой слабой разрешенной фракции (0.84 / 0.57 / 0.60 /
//    0.57 / 0.57); на бронзе 0.59 против 0.74, и по очкам тоже ниже;
//  - великаны (отчет 38): с алмаза индекс побед 0.86 / 1.00 / 0.86 (алмаз … божество)
//    против самой слабой разрешенной фракции 0.43 / 0.53 / 0.37, по очкам тоже выше;
//    на золоте 0.52 против 0.59, на бронзе и серебре намного ниже;
//  - гоблины (отчет 39): с золота индекс побед 0.69 / 0.65 / 0.53 / 0.53 (золото …
//    божество) против самой слабой разрешенной фракции 0.56 / 0.56 / 0.62 / 0.48. На
//    рубине чуть ниже, разрыв на уровне шума; на бронзе и серебре ниже заметно
export const BOT_FACTION_MIN_LEAGUE = {
  [FACTIONS.GIANTS]: LEAGUES.DIAMOND,
  [FACTIONS.SUCCUBES]: LEAGUES.SILVER,
  [FACTIONS.GOBLINS]: LEAGUES.GOLD,
};

const LEAGUE_ORDER = Object.values(LEAGUES);

/**
 * Лига бота для допуска фракций. Явный бот рейтингового матча (isVisibleBot)
 * играет с бонусом своей лиги; неявные боты рейтинга, боты обычных сетевых
 * лобби и демо-партии играют без бонуса — для них это бронза, какой бы ни была
 * лига их аккаунта по рейтингу
 */
export const getBotFactionLeagueId = (botPlayer) => (
  botPlayer && botPlayer.isVisibleBot && botPlayer.leagueId ? botPlayer.leagueId : LEAGUES.BRONZE
);

/** Достается ли фракция боту лиги leagueId (без лиги — бронза) */
export const checkIfBotFactionAllowed = (factionId, leagueId = LEAGUES.BRONZE) => {
  if (BOT_EXCLUDED_FACTIONS.includes(factionId)) {
    return false;
  }
  const minLeagueId = BOT_FACTION_MIN_LEAGUE[factionId];
  if (!minLeagueId) {
    return true;
  }
  const leagueIndex = LEAGUE_ORDER.indexOf(leagueId);
  return (leagueIndex === -1 ? 0 : leagueIndex) >= LEAGUE_ORDER.indexOf(minLeagueId);
};

/**
 * Убирает из набора фракций те, что запрещены ботам, и те, что не положены
 * его лиге (leagueId, по умолчанию — бронза).
 * Если после фильтра не осталось ничего (весь набор запрещен) — возвращает
 * исходный набор: бот обязан получить фракцию, иначе лобби зависнет на выборе,
 * а демо-партия не запустится.
 *
 * @param {string[]} pool
 * @param {string} [leagueId]
 * @returns {string[]}
 */
export const filterBotFactionPool = (pool, leagueId = LEAGUES.BRONZE) => {
  const allowed = (pool || []).filter((factionId) => checkIfBotFactionAllowed(factionId, leagueId));

  return allowed.length > 0 ? allowed : pool;
};
